import { Link } from 'react-router-dom'

const currentYear = new Date().getFullYear()

export function Footer() {
  return (
    <footer className="mt-auto border-t border-light-border py-3 px-4">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[#8B8FA7]">
        <span>
          &copy; {currentYear}{' '}
          <a
            href="https://www.elorion.fr"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-orion-primary transition-colors"
          >
            Elorion
          </a>
          . Tous droits r&#233;serv&#233;s.
        </span>
        <div className="flex items-center gap-4">
          <Link to="/legal/mentions" className="hover:text-orion-primary transition-colors">
            Mentions l&#233;gales
          </Link>
          <Link to="/legal/cgu" className="hover:text-orion-primary transition-colors">
            CGU
          </Link>
          <Link to="/legal/confidentialite" className="hover:text-orion-primary transition-colors">
            Confidentialit&#233;
          </Link>
        </div>
      </div>
    </footer>
  )
}
